import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  padding: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
`

export const titleStyle: React.CSSProperties = {
  color: '#000',
  fontSize: '24px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '32px'
}

export const descriptionStyle: React.CSSProperties = {
  color: 'rgba(0, 0, 0, 0.85)',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '22px'
}
